import type { BackendRouteDefinition } from '../types';
import { createFirmOnboardingFormsRoute } from './createFirmOnboardingForms';
import { updateIdentityRoute } from './updateIdentity';
import { updateMerchantRoute } from './updateMerchant';

export const otherRoutes = {
  getApiVersion: {
    transport: 'api',
    method: 'GET',
    path: '/version',
  },
  createFirmOnboardingForms: createFirmOnboardingFormsRoute,
  updateIdentity: updateIdentityRoute,
  updateMerchant: updateMerchantRoute,
} as const satisfies Record<string, BackendRouteDefinition>;
